/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundleDetailModel} from '../../../models/bundle/bundle-detail/bundle-detail.model';
import {InfoChartDataModel} from '../../../../shared/info-chart/models/info-chart-data.model';
import {BundleInformationTableBundleDataModel} from '../../../bundle-information-table/models/bundle-information-table-bundle-data.model';
import {PeriodBundlesTableColumnEnum} from '../period-bundles-table-column.enum';
import {PeriodDetailModel} from '../../../models/period/period-detail/period-detail.model';
import {TableLineModel} from '../../../../shared/table/models/table-line.model';
import {BundlePositionsDetailModel} from '../../../models/bundle/bundle-positions-detail/bundle-positions-detail.model';

export class PeriodBundlesTableInfoChartDataMapper {

    private constructor() {
    }

    static fromBundleDetailModelToInfoChartDataModelArray(input: BundleDetailModel[]): InfoChartDataModel<string>[] {
        return input?.map((element) => PeriodBundlesTableInfoChartDataMapper.fromBundleDetailModelToInfoChartDataModel(element));
    }

    static fromBundleDetailModelToInfoChartDataModel(input: BundleDetailModel): InfoChartDataModel<string> {
        let model: InfoChartDataModel<string> = null;

        if (input != null) {
            model = {
                identifier: input.number,
                status: input.status?.code,
                value: input.totalValue,
                description: input.number
            };
        }
        return model;
    }

    static fromBundleDetailModelToBundleInformationTableBundleDataModel(input: Partial<BundleDetailModel>,
                                                                        periodDetail: Partial<PeriodDetailModel>,
                                                                        line: Partial<TableLineModel<unknown,
                                                                                BundlePositionsDetailModel[]>>):
            BundleInformationTableBundleDataModel {
        let model: BundleInformationTableBundleDataModel = null;


        if (input != null && line != null) {
            model = {
                periodCode: periodDetail?.code,
                status: line?.data?.get(PeriodBundlesTableColumnEnum.STATUS)?.cellValue?.data,
                periodType: periodDetail?.periodType,
                timePeriod: periodDetail?.timePeriod,
                bundleCloseDate: input?.closedOn,
                bundleTotalAmount: input?.totalValue,
                bundleNumber: line?.identifier != null ? line.identifier : input.number,
                metadata: input?.metadata,
                bundleAdditionalCriteria: input?.criteria,
                availableActions: input?.availableActions
            };
        }
        return model;
    }
}
